import { createFeatureSelector } from '@ngrx/store';

import { State } from '../models';
import { CONFIGSTRIP_FEATURE_KEY } from '../state-config';

/**
 * config strip feature selector
 */
export const selectConfigStripState = createFeatureSelector<State>(
  CONFIGSTRIP_FEATURE_KEY,
);
